import { useState, useCallback, useEffect, useRef } from 'react';

export function useSidebarState() {
  const [collapsed, setCollapsed] = useState(true);
  const enabledRef = useRef(false);

  // Delay enabling hover behavior to prevent expansion on page load
  // when cursor happens to be over the sidebar area
  useEffect(() => {
    const timer = setTimeout(() => {
      enabledRef.current = true;
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  const expand = useCallback(() => {
    if (enabledRef.current) setCollapsed(false);
  }, []);

  const collapse = useCallback(() => setCollapsed(true), []);

  return { collapsed, expand, collapse };
}
